<app-breadcrumb [master]="'Marketing'" [parentName]="'Wyniki konkursów'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="list-filter list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="list-filter list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-regionals class="list-filter list-filter-long"
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny'"
      [(ngModel)]="initialFilters.regional" name="regional"
    ></app-dict-regionals>

    <mat-form-field class="list-filter list-filter-long">
      <mat-label>Nazwa konkursu</mat-label>
      <input matInput name="competitionName" [(ngModel)]="initialFilters.competitionName">
    </mat-form-field>

    <app-dict-warehouse-products
      label="Produkt"
      [(ngModel)]="initialFilters.warehouseProduct" name="warehouseProduct">
    </app-dict-warehouse-products>

    <mat-form-field class="list-filter">
      <mat-label>Konkurs rozliczany na</mat-label>
      <mat-select [(ngModel)]="initialFilters.settledOn" name="settledOn">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">OFWCA</mat-option>
        <mat-option [value]="0">Partner</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="list-filter">
      <mat-label>Wymagany protokół</mat-label>
      <mat-select [(ngModel)]="initialFilters.protocol" name="protocol">
        <mat-option [value]="undefined">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      [multiple]="false" label="Status"
      class="list-filter"
      dictType="wz_status"
      [skipKeys]=[WZ_STATUS_IN_PREPARATION]
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <mat-form-field appearance="standard" class="list-filter">
      <mat-label>Dodany protokół</mat-label>
      <mat-select [(ngModel)]="initialFilters.addedProtocol" name="addedProtocol">
        <mat-option [value]="undefined">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="!competitionWzObject"
        [disabled]="!(userPermissions | async)?.marketing.write || !hasSelectedItems"
        (click)="addToWZ()"
        mat-stroked-button
        color="primary"><mat-icon>add</mat-icon> <span> Dodaj do WZ </span></button>

      <button *ngIf="competitionWzObject"
              [disabled]="!(userPermissions | async)?.marketing.write || !hasSelectedItems"
              (click)="addToExistingWZ()"
              mat-stroked-button
              color="primary"><mat-icon>add</mat-icon> <span> Dodaj do WZ </span>
      </button>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).marketing.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).marketing.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="participantsDataSource">

    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef> Wybierz </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox *ngIf="element?.status?.key === WZ_STATUS_TO_RELEASE && element.warehouseProduct && element.amount" [formControl]="element.checkbox"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="awardId">
      <th mat-header-cell *matHeaderCellDef> Nagroda (przypisana z bazy po nr ID) </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.uuid]">{{element?.warehouseProduct?.productName ? element?.warehouseProduct?.productName : ""}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element?.status?.color + '-button'">{{element?.status?.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="competitionSettledOn">
      <th mat-header-cell *matHeaderCellDef> Konkurs rozliczany na </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element?.competitionImport?.partner">
          Partner
        </ng-container>

        <ng-container *ngIf="element?.competitionImport?.ofwca">
          OFWCA
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="protocol">
      <th mat-header-cell *matHeaderCellDef> Wymagany protokół </th>
      <td mat-cell *matCellDef="let element">
        {{element?.warehouseProduct?.protocol ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Liczba </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.amount">{{element?.amount}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="laureate">
      <th mat-header-cell *matHeaderCellDef> Laureat </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner && element.competitionImport.partner">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.uuid]">{{element?.partner?.shortName ? element?.partner?.shortName : ""}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca && element.competitionImport.ofwca">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/wyniki/szczegoly', element?.uuid]">{{element?.ofwca?.fullName ? element?.ofwca?.fullName : ""}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner && element.competitionImport.partner">
          {{element.partner?.assetsRegional?.firstName}} {{element.partner?.assetsRegional?.lastName}}
        </ng-container>

        <ng-container *ngIf="element.ofwca && element.competitionImport.ofwca">
          {{element.ofwca?.assetsRegional?.firstName}} {{element.ofwca?.assetsRegional?.lastName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="competition">
      <th mat-header-cell *matHeaderCellDef> Konkurs </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/wyniki-konkursow/szczegoly', element?.competitionImport?.uuid]">{{element?.competitionImport?.competitionName ? element?.competitionImport?.competitionName : ""}}</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
